import React from 'react'
import Pagination from 'react-bootstrap/Pagination';

function CustomPagination({ currentPage, totalPages, onPageChange }) {

  let pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }

  // Function to handle click on a page
  const handleClick = (page) => {
    if (onPageChange) onPageChange(page);
  };

  return (
    <>
      <nav aria-label="Page navigation" className="pagination-style-1">

        {
          (totalPages > 0) &&
          <>
            <Pagination className="pagination mb-0">
              <Pagination.Item
                onClick={() => handleClick(currentPage - 1)}
                disabled={currentPage === 1 ? true : false} style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              >
                <img src="/images/svg/pagination-left.svg" width={7} height={10} alt="icon" />
              </Pagination.Item>

              {
                (currentPage > 2) && (totalPages !== 3) &&
                <Pagination.Ellipsis onClick={() => handleClick(currentPage - 2)} />
              }
              {
                (currentPage === totalPages) && (totalPages > 2) &&
                <Pagination.Item
                  active={currentPage === (currentPage - 2)}
                  onClick={() => handleClick(currentPage - 2)}
                >
                  {currentPage - 2}
                </Pagination.Item>
              }

              {
                (currentPage !== 1) &&
                <Pagination.Item
                  active={currentPage === (currentPage - 1)}
                  onClick={() => handleClick(currentPage - 1)}
                >
                  {currentPage - 1}
                </Pagination.Item>
              }
              <Pagination.Item
                active={currentPage}
                onClick={() => handleClick(currentPage)}
              >
                {currentPage}
              </Pagination.Item>
              {
                (currentPage !== totalPages) &&
                <Pagination.Item
                  active={currentPage === (currentPage + 1)}
                  onClick={() => handleClick(currentPage + 1)}
                >
                  {currentPage + 1}
                </Pagination.Item>
              }
              {
                (currentPage === 1) && (totalPages > (currentPage + 1)) &&
                <Pagination.Item
                  active={currentPage === (currentPage + 2)}
                  onClick={() => handleClick(currentPage + 2)}
                >
                  {currentPage + 2}
                </Pagination.Item>
              }

              {
                (totalPages > (currentPage + 1)) && (totalPages !== 3) &&
                <Pagination.Ellipsis onClick={() => handleClick(currentPage + 2)} />
              }

              <Pagination.Item
                onClick={() => handleClick(currentPage + 1)}
                disabled={currentPage === totalPages ? true : false} style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              >
                <img src="/images/svg/pagination-right.svg" width={7} height={10} alt="icon" />
              </Pagination.Item>
            </Pagination>

            {/* <select id="industry-select" className="form-select" aria-label="Select ">
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">100</option>
                      </select> */}
          </>
        }

      </nav>
    </>
  );
}

export default CustomPagination